import Logo from '../layout/Logo'

type OrderNavBarProps = {
	className?: string
}

export default function OrderNavBar({ className = '' }: OrderNavBarProps) {
	return (
		<div
			className={`order-nav-bar mt-7 after:content-[''] after:block after:w-full after:h-px after:bg-black-rt/10 after:mt-6 ${className}`}>
			<Logo />
		</div>
	)
}
